<template>
  <v-dialog v-model="dialog" scrollable max-width="600px" persistent>
    <v-card>
      <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
        <h2 style="color:white">Nieuw abonnement</h2>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeAddMembershipDialog()" :disabled="uploading">
          <v-icon dark color="white">close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="hogans-alerts">
        <v-alert
          v-if="feedback"
          :value="true"
          type="warning"
        >
        {{ feedback }} 
        </v-alert>
      </div>

      <v-divider></v-divider>

      <v-card-text class="py-2">
        <v-form ref="AddClientQueueForm" v-model="valid" lazy-validation>

          <div v-if="step == 1">
            <v-select
              class="mt-4"
              v-model="newMembership.type"
              :items="membershipTypes"
              label="Selecteer type abonnement"
              item-text="name"
              item-value="id"
              outlined
              dense
              required
              :rules="requiredRules"
            ></v-select> 
        
            <div v-if="newMembership.type == 'new'" class="pb-4">
              <h2 class="mb-2"><strong>3 maanden abonnement Hairloxx</strong></h2>
              <p>Je hebt zojuist het eerste bedrag van dit abonnement betaald. Hierna zal ditzelfde bedrag, welke hieronder is genoemd, nog twee keer automatisch geïncasseerd worden.</p>
              <p>Door ondertekening van deze overeenkomst machtig je Beauty by Roos Hairextensions om het afgesproken bedrag, welke hieronder is genoemd, van je rekening af te schrijven. Beauty by Roos zal deze incasso's aan het einde van de komende twee maanden verzorgen. Het incassanten ID van Beauty by Roos is NL83ZZZ08164562000.</p>
              <p>Dit contract is niet tussentijds opzegbaar om welke reden dan ook. Het verwijderen van de hairextensions is in dit contract opgenomen. Het verwijderen dient binnen 6 maanden na ondertekening van dit contract te worden uitgevoerd. Hierna vervalt de plicht van Beauty by Roos om deze dienst te leveren. </p>
            </div>

            <div v-if="newMembership.type == 'extension'"  class="pb-4"> 
              <h2  class="mb-2"><strong>Verleningen - 3 maanden abonnement Hairloxx</strong></h2>
              <p>Je hebt zojuist het eerste bedrag van dit abonnement betaald. Hierna zal ditzelfde bedrag, welke hieronder is genoemd, nog twee keer automatisch geïncasseerd worden.</p>
              <p>Door ondertekening van deze overeenkomst machtig je Beauty by Roos Hairextensions om het afgesproken bedrag, welke hieronder is genoemd, van je rekening af te schrijven. Beauty by Roos zal deze incasso's aan het einde van de komende twee maanden verzorgen. Het incassanten ID van Beauty by Roos is NL83ZZZ08164562000.</p>
              <p>Dit contract is niet tussentijds opzegbaar om welke reden dan ook. Het verwijderen van de hairextensions is in dit contract opgenomen. Het verwijderen dient binnen 6 maanden na ondertekening van dit contract te worden uitgevoerd. Hierna vervalt de plicht van Beauty by Roos om deze dienst te leveren. </p>
            </div>

            <div v-if="newMembership.type == 'newFour'" class="pb-4">
              <h2 class="mb-2"><strong>4 maanden abonnement Hairloxx</strong></h2>
              <p>Je hebt zojuist het eerste bedrag van dit abonnement betaald. Hierna zal ditzelfde bedrag, welke hieronder is genoemd, nog drie keer automatisch geïncasseerd worden.</p>
              <p>Door ondertekening van deze overeenkomst machtig je Beauty by Roos Hairextensions om het afgesproken bedrag, welke hieronder is genoemd, van je rekening af te schrijven. Beauty by Roos zal deze incasso's aan het einde van de komende twee maanden verzorgen. Het incassanten ID van Beauty by Roos is NL83ZZZ08164562000.</p>
              <p>Dit contract is niet tussentijds opzegbaar om welke reden dan ook. Het verwijderen van de hairextensions is in dit contract opgenomen. Het verwijderen dient binnen 6 maanden na ondertekening van dit contract te worden uitgevoerd. Hierna vervalt de plicht van Beauty by Roos om deze dienst te leveren. </p>
            </div>

            <div v-if="newMembership.type == 'extensionFour'"  class="pb-4"> 
              <h2  class="mb-2"><strong>Verleningen - 4 maanden abonnement Hairloxx</strong></h2>
              <p>Je hebt zojuist het eerste bedrag van dit abonnement betaald. Hierna zal ditzelfde bedrag, welke hieronder is genoemd, nog vier keer automatisch geïncasseerd worden.</p>
              <p>Door ondertekening van deze overeenkomst machtig je Beauty by Roos Hairextensions om het afgesproken bedrag, welke hieronder is genoemd, van je rekening af te schrijven. Beauty by Roos zal deze incasso's aan het einde van de komende twee maanden verzorgen. Het incassanten ID van Beauty by Roos is NL83ZZZ08164562000.</p>
              <p>Dit contract is niet tussentijds opzegbaar om welke reden dan ook. Het verwijderen van de hairextensions is in dit contract opgenomen. Het verwijderen dient binnen 6 maanden na ondertekening van dit contract te worden uitgevoerd. Hierna vervalt de plicht van Beauty by Roos om deze dienst te leveren. </p>
            </div>

            <div v-if="newMembership.type == 'extensionSeiseta'"  class="pb-4"> 
              <h2  class="mb-2"><strong>Verleningen - 3 maanden abonnement Seiseta</strong></h2>
              <p>Je hebt zojuist het eerste bedrag van dit abonnement betaald. Hierna zal ditzelfde bedrag, welke hieronder is genoemd, nog twee keer automatisch geïncasseerd worden.</p>
              <p>Door ondertekening van deze overeenkomst machtig je Beauty by Roos Hairextensions om het afgesproken bedrag, welke hieronder is genoemd, van je rekening af te schrijven. Beauty by Roos zal deze incasso's aan het einde van de komende twee maanden verzorgen. Het incassanten ID van Beauty by Roos is NL83ZZZ08164562000.</p>
              <p>Dit contract is niet tussentijds opzegbaar om welke reden dan ook. Het verwijderen van de hairextensions is in dit contract opgenomen. Het verwijderen dient binnen 6 maanden na ondertekening van dit contract te worden uitgevoerd. Hierna vervalt de plicht van Beauty by Roos om deze dienst te leveren. </p>
            </div>

            <div v-if="newMembership.type == 'extensionFourSeiseta'"  class="pb-4"> 
              <h2  class="mb-2"><strong>Verleningen - 4 maanden abonnement Seiseta</strong></h2>
              <p>Je hebt zojuist het eerste bedrag van dit abonnement betaald. Hierna zal ditzelfde bedrag, welke hieronder is genoemd, nog vier keer automatisch geïncasseerd worden.</p>
              <p>Door ondertekening van deze overeenkomst machtig je Beauty by Roos Hairextensions om het afgesproken bedrag, welke hieronder is genoemd, van je rekening af te schrijven. Beauty by Roos zal deze incasso's aan het einde van de komende twee maanden verzorgen. Het incassanten ID van Beauty by Roos is NL83ZZZ08164562000.</p>
              <p>Dit contract is niet tussentijds opzegbaar om welke reden dan ook. Het verwijderen van de hairextensions is in dit contract opgenomen. Het verwijderen dient binnen 6 maanden na ondertekening van dit contract te worden uitgevoerd. Hierna vervalt de plicht van Beauty by Roos om deze dienst te leveren. </p>
            </div>

            <v-text-field
              
              label="Bedrag per maand"
              v-model="newMembership.amount"
              :rules="requiredRules"
              outlined
              dense
              persistent-hint
              hint="In te vullen door Beauty by Roos medewerker"
              required
            ></v-text-field>
          </div>

          <div v-if="step == 2" >

            <div v-if="!selectedFromDossier" class="pa-2">

            <h3>Zoek klant in Salonhub</h3>
            <v-text-field
                dense
                outlined
                :color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].background"    
                style="width: 100%;"
                hide-details
                autocomplete="disabled"
                placeholder="naam/email/telefoon"
                label="Vind een klant"
                prepend-inner-icon="search"
                :append-inner-icon="loaderSearch ? 'fas fa-circle-notch fa-spin' : ''"
                v-model="zoekSalonhubClient"
                clearable
              ></v-text-field>

                <div v-if="zoekSalonhubClient && zoekSalonhubClient.length > 2" class="searchResults">
                <v-card
                  style="position: absolute; width: 100%; z-index:99; max-height: 260px; overflow-y: scroll;"
                  class="mx-auto"
                  tile
                  >
                  <v-list v-for="(resultsSearch, index) in searchResultsSalonhub" :key="index"  two-line subtitle dense class="pa-0 ma-0">
                    <v-list-item @click="setClientData(resultsSearch), searchResultsSalonhub = [], zoekSalonhubClient = ''">
                      <v-list-item-avatar >
                        <v-icon class="my-0" style="background-color: #eee;">person</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{ resultsSearch.firstname }} {{ resultsSearch.middlename }} {{ resultsSearch.lastname }}</v-list-item-title>
                        <v-list-item-subtitle>{{resultsSearch.address}} <span style="color: rgba(0,0,0,0.54);" v-if="resultsSearch.address">{{resultsSearch.number}}, </span>{{resultsSearch.city}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="index + 1 < searchResultsSalonhub.length"></v-divider> 
                  </v-list>

                </v-card>
              </div>
            </div>

            
            <v-container grid-list-sm class="ma-0 pa-2" fluid>
              <h3 class="pt-2">Contactgegegevens</h3>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-text-field
                    label="Voornaam"
                    v-model="newMembership.firstName"
                    :rules="requiredRules"
                    dense
                    outlined
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    label="Achternaam"
                    v-model="newMembership.lastName"
                    :rules="requiredRules"
                    dense
                    outlined
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Geboortedatum"
                    v-model="newMembership.birthday"
                    :rules="requiredRules"
                    dense
                    outlined
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Adres + Huisnummer"
                    v-model="newMembership.street"
                    :rules="requiredRules"
                    dense
                    outlined
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    label="Postcode"
                    v-model="newMembership.zipcode"
                    :rules="requiredRules"
                    dense
                    outlined
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    label="Plaats"
                    v-model="newMembership.city"
                    :rules="requiredRules"
                    dense
                    outlined
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    label="Land"
                    :items="countries"
                    item-text="name"
                    item-value="id"
                    v-model="newMembership.country"
                    dense
                    outlined
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>

            <!-- label="Met het ondertekenen van dit contract ga ik akkoord met de Algemene Voorwaarden van Beauty by Roos Hairextensions en verklaar ik dat ik deze voorwaarden heb gelezen" -->

            <v-container grid-list-md class="ma-0 pa-0" >
              <h4 style="font-size: 18px; font-weight: bold" class="mb-2">Algemene voorwaarden</h4>
              <v-checkbox
                class="pa-0 ma-0"
                v-model="newMembership.agreeTermsAndConditions"
                
              >
              <template v-slot:label>
                <div>
                  Met het ondertekenen van dit contract ga ik akkoord met de 

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        :href="countryTerms"
                        @click.stop
                        v-on="on"
                      >Privacy policy</a>
                    </template>
                    Opent in een nieuwe venster
                  </v-tooltip>
                  en geef ik toestemming voor de verwerking van mijn persoonsgegevens, waaronder de beperkte gegevens op mijn identiteits- en bankkaart (naam, adres, geboortedatum, bankrekening- en documentnummer).
                </div>
              </template>
            </v-checkbox>


              <div style="max-height: 200px; overflow: scroll; background-color:#eeeeee; padding: 5px; border: 1px solid #333333">
                <p>Deze algemene voorwaarden van Beauty by Roos B.V. zijn van toepassing op alle door ons gesloten overeenkomsten, behandelingen en afspraken.</p>

                <p><strong>- Annuleringsbeleid -</strong><br>
                Gemaakte afspraken kunnen tot maximaal 48 uur van tevoren kosteloos geannuleerd worden. Bij annulering binnen 48 uur is Beauty by Roos gemachtigd €75,00 per gereserveerd uur in rekening te brengen. Hier wordt uitgegaan van de voor u gereserveerde tijd voor de afspraak, welke terug te vinden is in de afspraakbevestiging. Ook wanneer u niet verschijnt op de gemaakte afspraak wordt aan u €75,00 per gereserveerd uur in rekening gebracht.</p>

                <p><strong>- Abonnement -</strong><br>
                  Voorwaarden bij het afsluiten van een abonnement:<br>
                  <ul class="number-list">
                    <li>Een minimale leeftijd van 18 jaar.</li>
                    <li>Je bent officieel in Nederland woonachtig.</li>
                    <li>Je bent in het bezit van een Nederlands paspoort of een Nederlands identiteitsbewijs.</li>
                    <li>Je hebt een Nederlandse bankrekening die op dezelfde naam staat als je Nederlandse paspoort of identiteitsbewijs.</li>
                    <li>Bovenstaande documenten dien je mee te nemen voordat er een abonnement kan worden afgesloten.</li>
                    <li>Je bent niet geregistreerd bij het Centraal Insolventieregister of het Centraal curatele- en bewindregister.</li>
                    <li>Je hebt in de laatste 12 maanden niet vaker dan 2 keer een termijn gestorneerd van eerder afgesloten abonnementen bij Beauty by Roos. Na 3 keer storneringen binnen 12 maanden mag je een half jaar geen abonnement meer afsluiten.</li>
                    <li>Een abonnement kan alleen voor eigen gebruik afgesloten worden. Het is niet mogelijk om voor een ander persoon een abonnement af te sluiten.</li>
                    <li>De eerste termijn van het abonnement dient tijdens de eerste behandeling in de salon met pin of creditcard voldaan te worden.</li>
                    <li>Indien er een betalingsachterstand ontstaat tijdens de looptijd van het abonnement, dient deze eerst voldaan te worden voordat je een nieuwe behandeling in een van onze salons kunt inplannen.</li>
                    <li>Bij het uitblijven van betalingen zijn wij genoodzaakt een incassobureau in te schakelen.</li>
                    <li>Abonnementen worden automatisch beëindigd na het einde van je contract. Wil je het abonnement verlengen, dan wordt er in de salon een nieuw abonnement voor je opgesteld. Hiervoor vragen wij opnieuw om je legitimatiebewijs en bankpas. Dit nieuwe abonnement zal na ondertekening van start gaan.</li>
                </ul>
                </p>
                <p><strong>- Betaling -</strong><br>
                Indien niet is gekozen voor een abonnement dient betaling per pin of creditcard, direct na de behandeling, te geschieden. Beauty by Roos accepteert geen contante betalingen.
                Indien gekozen is voor een abonnement worden de termijnbetalingen middels een automatische incasso voldaan. U dient hiervoor een machtiging te verstrekken. Indien de automatische incasso om wat voor reden dan ook niet kan worden uitgevoerd of de incasso wordt gestorneerd, laat dit uw betalingsverplichting onverlet. De termijnbedragen dienen uiterlijk op de laatste dag van de maand waarop de termijn betrekking heeft, te zijn voldaan op de bankrekening van Beauty by Roos. Bij gebreke daarvan bent u vanaf dat moment wettelijke rente verschuldigd. Ook maakt Beauty by Roos dan aanspraak op vergoeding van buitengerechtelijke incassokosten ten bedrage van 15% van de hoofdsom, met een minimum van €40,00.</p>

                <p><strong>- Voor- en nafoto's -</strong><br>
                Voor een behandeling na een behandeling worden altijd foto’s gemaakt van het haar. Deze foto’s worden opgeslagen in het klantendossier. Indien u geen foto’s wilt laten maken, kan de behandeling niet plaatsvinden. Op deze foto’s wordt u  onherkenbaar in beeld gebracht.</p>

                <p><strong>- Toestemmingsformulier -</strong><br>
                Tijdens de behandeling kan er gevraagd wordt om een toestemmingsformulier te ondertekenen. In dit formulier wordt aangegeven dat u een behandeling wenst die tegen het advies in gaat van de hairextensionspecialist. Op het moment van tekenen vervalt de garantie.</p>

                <p><strong>- Verzorgingsadvies -</strong><br>
                Ons verzorgingsadvies, welke u mee krijgt op uw eerste afspraak en welke na te lezen is op onze website, maakt onderdeel uit van deze algemene voorwaarden. Hairextensions kunnen bij een verkeerde verzorging of te lange draagtijd schadelijk zijn voor uw eigen haar. Leef het verzorgingsadvies goed na en laat uw hairextensions nooit langer dan 4 maanden zitten.
                Indien het verzorgingsadvies niet wordt nageleefd is Beauty by Roos niet aansprakelijk voor schade aan het eigen haar dan wel aan de hairextensions.</p>

                <p><strong>- Klachtenafhandeling -</strong><br>
                Indien u een klacht heeft of indien er sprake is van schade aan uw eigen haar of de hairextensions dient u te allen tijde direct, maar in ieder geval binnen 3 dagen na het ontstaan van de klacht of de schade, contact op te nemen met Beauty by Roos. Beauty by Roos zal in dat geval haar uiterste best doen om de schade aan uw eigen haar dan wel de hairextensions te beperken. U dient hieraan uw medewerking te geven en Beauty by Roos hiertoe in de gelegenheid te stellen. Bij gebreke daarvan kan Beauty by Roos niet aansprakelijk worden gehouden voor enige schade of vordering.
                Een klacht laat uw betalingsverplichting onverlet. Het geeft geen recht om verdere betalingen op te schorten, te verrekenen of om de overeenkomst te ontbinden.</p>

                <p><strong>- Beperking aansprakelijkheid -</strong><br>
                Indien Beauty by Roos op enigerlei wijze aansprakelijk is te houden voor enige schade, dan is haar schade beperkt tot directe schade en maximaal tot het bedrag dat gemoeid is met de desbetreffende behandeling. Gevolgschade is in ieder geval uitgesloten voor vergoeding
                Indien u uw hairextensions zelf heeft verwijderd dan wel door een derde heeft laten verwijderen is Beauty by Roos niet aansprakelijk voor eventuele schade aan uw eigen haar ten gevolge van dit verwijderen of voor de schade aan de hairextensions
                Op het moment dat een derde uw hairextensions heeft behandeld is Beauty by Roos niet aansprakelijk voor eventuele schade aan de hairextensions dan wel uw eigen haar.
                Beauty by Roos is niet aansprakelijk voor schade veroorzaakt door een verstoorde hormoonhuishouding, medicijngebruik, stress, zwangerschap, een operatieve ingreep, allergische reacties dan wel andere omstandigheden welke van invloed kunnen zijn op de kwaliteit van uw eigen haar. </p>

                <p><strong>- Garantie -</strong><br>
                Er wordt twee maanden garantie verleend bij aankoop van een garantiepakket in de salon. Er wordt garantie gegeven op onderstaande situaties:
                <ul class="medical-list">
                    <li>Garantie wordt gegeven op uitgevallen hairextensions. Dit betekent dat hairextensions, die binnen twee maanden na plaatsing uitvallen, kosteloos worden teruggeplaatst. Alleen wanneer u de eventueel uitgevallen plukjes bewaart en meeneemt naar Beauty by Roos zal Beauty by Roos de plukjes kosteloos terugplaatsen.</li>
                    <li>Garantie wordt gegeven op de kwaliteit van het haar van de hairextensions van Hairloxx Professional.</li>
                </ul>

                De garantie vervalt in de volgende situaties:<br>
                <ul class="number-list">
                    <li>Na 2 maanden draagtijd.</li>
                    <li>Het niet navolgen van het verzorgingsadvies zoals vermeld op de website van Beauty by Roos (bijvoorbeeld het ontstaan van klitten boven de aanhechtingen door het niet voldoende borstelen, slapen met een staart of vlecht, slapen met nat haar, etc.).</li>
                    <li>Het gebruik van andere verzorgingsproducten dan Hairloxx.</li>
                    <li>Chemische behandelingen zoals blonderen, ontkleuren, lichter verven, chemisch straightening, permanenten of andere schadelijke chemische behandelingen. </li>
                    <li>Bij schade aan de aanhechtingen door gebruik van hittebronnen zoals een stijltang.</li>
                    <li>Het laten knippen, bijsnijden, herplaatsen of verwijderen van je hairextensions door iemand anders dan Beauty by Roos.</li>
                    <li>Het verkleuren van de hairextensions door producten zoals zonnebrandcrème.</li>
                    <li>Het niet tijdig melden van een klacht. Een klacht dient binnen minimaal 3 dagen aan ons gemeld te zijn na het ontstaan van de klacht.</li>
                    <li>Het niet willen komen of het niet komen opdagen bij een controleafspraak.</li>
                    <li>Bij het niet volgen van de klachtenprocedure.</li>
                    <li>In al deze gevallen vervalt de garantie direct. Beauty by Roos betaalt nooit een behandeling terug.</li>
                  </ul>


                De garantie is geen 'niet goed, geld terug'-garantie.<br><br>

                De garantie op uitgevallen hairextensions geldt alleen indien u de uitgevallen plukken door Beauty by Roos laat terugplaatsen. Kosten van derden ter zake het terugplaatsen dan wel het plaatsen van nieuwe hairextensions door een derde en/of aanvullende behandelingen van uzelf of een derde worden niet vergoed. <br><br>

                Gratis serviceafspraken (styling- en bijsnijdafspraken) moeten binnen 3 maanden na het plaatsen van de hairextensions hebben plaatsgevonden. Niet afgenomen serviceafspraken vervallen na deze 3 maanden en kunnen nooit worden omgezet in een terugbetaling.</p>

                <p><strong>- Reviews -</strong><br>
                Reviews die worden geplaatst op Google, Facebook, Trustpilot en andere reviewsites worden door Beauty by Roos gecontroleerd. Wij vergelijken de naam van de reviewer met ons klantenbestand. Indien iemand een review plaatst die geen klant is (geweest) van Beauty by Roos, dan melden wij dit direct bij het platform als zijnde ongepast. Indien het een review betreft waarbij onterecht en misleidende informatie wordt gegeven dan sommeren wij de reviewer de review te verwijderen.
                Beauty by Roos of medewerkers van Beauty by Roos plaatsen geen positieve reviews op review sites om Beauty by Roos te promoten.</p>

                <p><strong>- Toepasselijk recht -</strong><br>
                Op alle door Beauty by Roos gesloten overeenkomsten en uitgevoerde werkzaamheden is Nederlands recht van toepassing. De rechter in het arrondissement van de vestiging van Beauty by Roos alwaar de overeenkomst is gesloten c.q. de werkzaamheden zijn uitgevoerd, is de rechter die bevoegdheid toekomt ter zake geschillen welke uit deze overeenkomst voortvloeien.</p>

                <p><strong>- Intellectuele Eigendom -</strong><br>
                Het kopiëren van, dan wel gedeeltelijk kopiëren van het verzorgingsadvies, deze algemene voorwaarden, de internet- en marketingteksten en de concepten van Beauty by Roos is niet toegestaan tenzij hiervoor schriftelijk toestemming is gegeven.</p>

                <p><strong>- Privacywet AVG -</strong><br>
                Bij het aangaan van de klant / leveranciersverhouding geeft u Beauty by Roos BV toestemming om gegevens over u en uw afspraken / behandeling(en) te verwerken in het kader van de te verlenen service. Deze toestemming omvat mede het:
                <ul class="medical-list">
                    <li>het verwerken van persoonsgegevens aanwezig in mijn klantendossier;</li>
                    <li>verstrekken van persoonsgegevens aan derden voor betalingen, automatische incasso’s etc;</li>
                </ul>

                Op https://www.beautybyroos.nl/privacy-verklaring/ kunt u onze volledige privacy verklaring lezen.<br><br>
                Op https://beautybyroos.nl/klachtenprocedure/ kunt u onze volledige klachtenprocedure lezen.
                </p>

              </div>

              <v-menu
                ref="dateDialog"
                :close-on-content-click="false"
                v-model="queueEndDateDialog"
                transition="scale-transition"
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{on}">
                  <v-text-field
                    class="mt-4"
                    :color="companyPrimaryColor"
                    v-on="on"
                    outlined
                    dense
                    v-model="signDateFormatted"
                    label="Ondertekend op"
                    append-icon="today"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  :color="companyPrimaryColor"
                  v-model="newMembership.signDate"
                  :min="today"
                  :show-current="true"
                  no-title
                  @input="queueEndDateDialog = false"
                ></v-date-picker>
              </v-menu>

              <v-select
                class="ma-1"
                dense
                outlined
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                :items="branches"
                item-text="branchName"
                item-value="id"
                v-model="newMembership.branch"
                label="Plaats"
                hide-details
              ></v-select>

              <!-- <div style="padding: 10px 0 0 0;">
                <p v-if="deviatingAdvice.type == 'new'" style="font-size: 14px;"><strong>Datum:</strong> {{ deviatingAdvice.timestamp | moment(" D MMM YYYY - H:mm") }}u</p>
              </div> -->
                
              <v-layout row wrap class="ma-0 pa-0">
                <v-flex x12>
                  <p class="pa-0 mb-1" style="font-size: 16px;"><strong>Handtekening</strong></p>
                  <vueSignature ref="signature" :sigOption="signatureOptions" :w="'100%'" :h="'140px'" style="border: 2px solid #333; border-radius: 8px; overflow: hidden"></vueSignature>
                  <v-btn small depressed class="my-2" @click="clearSignature">Wissen</v-btn> 
                </v-flex>
              </v-layout>
            </v-container> 
          </div>

          <div v-if="step == 3" >
            <div class="upload-image-wrapper clear pt-4">
              <div class="upload-image-icon">
                <v-icon>image</v-icon>
              </div>
              <div class="upload-image">
                <p class="ma-0">Upload Paspoort/Id-kaart</p>
                <div v-if="newMembership.clientIdFile" class="logo-upload-preview">
                  <img :src="newMembership.clientIdFile">
                </div>
                <v-btn raised :color="companyPrimaryColor" dark @click="onIdFileSelect">Kies afbeelding</v-btn>
                <input
                  type="file"
                  style="display: none;"
                  ref="idFileInput"
                  accept="image/*"
                  @change="onIdFilePicked">
              </div>
            </div>

            <div class="upload-image-wrapper clear pt-4">
              <div class="upload-image-icon">
                <v-icon>image</v-icon>
              </div>
              <div class="upload-image">
                <p class="ma-0">Upload Kopie pinpas</p>
                <div v-if="newMembership.clientCardFile" class="logo-upload-preview">
                  <img :src="newMembership.clientCardFile">
                </div>
                <v-btn raised :color="companyPrimaryColor" dark @click="onCardFileSelect">Kies afbeelding</v-btn>
                <input
                  type="file"
                  style="display: none;"
                  ref="cardFileInput"
                  accept="image/*"
                  @change="onCardFilePicked">
              </div>
            </div>

            <v-text-field
              class="mt-4"
              :color="companyPrimaryColor"
              outlined
              dense
              v-model="newMembership.iban"
              label="IBAN (rekeningnummer)"
            ></v-text-field>

          </div>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
              <v-btn
                v-if="step == 1"
                outlined
                depressed
                :disabled="uploading"
                color="#8B93A6"
                @click="closeAddMembershipDialog()"
                >
                Annuleren
              </v-btn>
              <v-btn
                v-if="step == 2 || step == 3"
                outlined
                depressed
                :disabled="uploading"
                color="#8B93A6"
                @click="goToPreview()"
                >
                Vorige
              </v-btn>
            </v-flex>
            <v-flex xs12 md6 class="text-right">
              <v-btn
                v-if="step == 1 || (step == 2 && !extendAgreement)"
                outlined
                :disabled="uploading"
                depressed
                color="#8B93A6"
                @click="goToNext()"
                >
                Volgende
              </v-btn>
              <v-btn
                v-if="step == 3 || (step == 2 && extendAgreement)"
                :dark="!uploading"
                :disabled="uploading"
                rounded
                :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                :color="companySecondaryColor"
                @click="addMembership()"
                >
                Abonnement afsluiten
                <v-icon right dark>chevron_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>
        
    </v-card>
  </v-dialog>
</template>


<script>
import { bus } from "../../main";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";;
import axios from "axios";
import platform from 'platform'; 
import moment from 'moment';
import vueSignature from "vue-signature"

export default {
  name: "add-membership-form",
  props: ['activeCompData'],
  components: {
    vueSignature
  },
  data() {
    return {
      selectedFromDossier: false,
      valid: false,
      step: 1,
      loaderSearch: false,
      zoekSalonhubClient: null,
      newMembership: {
        agreeTermsAndConditions: false,
        firstName: null,
        lastName: null,
        street: null,
        zipcode: null,
        birthday: null,
        city: null,
        type: 'new',
        country: 'nl',
        signDate: null,
        branch: null,
        amount: 0,
        salonhubId: null,
        clientIdFile: null,
        clientCardFile: null,
        clientSignature: null,
        iban: null
      },
      countries: [
        {
          id: "nl",
          name: "Nederland"
        },
        {
          id: "be",
          name: "België"
        }
      ],
      signatureOptions: {
        backgroundColor: '#eeeeee',
      },
      membershipTypes: [
        {
          id: "new",
          name: 'Nieuw (3 maanden)'
        },
        {
          id: "extension",
          name: 'Verlenging (3 maanden)'
        },
        {
          id: "newFour",
          name: 'Nieuw (4 maanden)'
        },
        {
          id: "extensionFour",
          name: 'Verlenging (4 maanden)'
        },

        {
          id: "extensionSeiseta",
          name: 'Verlenging Seiseta (3 maanden)'
        },
        {
          id: "extensionFourSeiseta",
          name: 'Verlenging Seiseta (4 maanden)'
        }
      ],
      branches: new Array(),
      queueEndDateDialog: false,
      requiredRules: [v => !!v || "Dit veld is verplicht"],

      today: null,
      emailRules: [
        v => !!v || "E-mail is verplicht",
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
      ],
      feedback: null,
      dialog: false,
      uploading: false,
      uploadProgress: 0,
      searchResultsSalonhub: new Array(),
      idFile: null,
      cardFile: null,
      idFilename: null,
      cardFilename: null,
      idImage: null,
      cardImage: null
    };
  },

  created(){
    bus.$on("openMembershipDialog", (id) =>{
      if(id){
        this.selectedFromDossier = true;
        this.getClientDataById(id);
      }
      this.loadBranches(),
      this.newMembership.signDate = moment().format("YYYY-MM-DD");
      console.log("this.newMembership.signDate: ", this.newMembership.signDate)
      this.dialog = true;
    });
  },

  methods: {
    closeAddMembershipDialog() {
      this.dialog = false;
      this.step = 1;
      this.selectedFromDossier = false;

      this.idFile = null;
      this.cardFile = null;
      this.idFilename = null;
      this.cardFilename = null;
      this.idImage = null;
      this.cardImage = null;
      // this.$emit("newMembershipDialogChange", false);
      // this.feedback = null;
      this.newMembership = {
        firstName: null,
        lastName: null,
        street: null,
        birthday: null,
        zipcode: null,
        city: null,
        type: 'new',
        amount: 0,
        signDate: null,
        salonhubId: null,
        agreeTermsAndConditions: false,
        newMembeclientSignaturership: null,
        clientIdFile: null,
        clientCardFile: null,
        clientSignature: null
      }
    },

    loadBranches() {
      this.newMembership.branch = null;
      db.collection("branches")
      .where("compId", "==", this.activeCompData.id)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let branchCollection = doc.data();
          branchCollection.id = doc.id;
          this.branches.push(branchCollection);
        });
      })
      .then(()=>{
        this.newMembership.branch = this.branches[0].id;
      })
    },

    setClientData(resultsSearch){
      this.newMembership.firstName = resultsSearch.firstname;
      this.newMembership.lastName = resultsSearch.middlename + " " + resultsSearch.lastname;
      this.newMembership.street = resultsSearch.address + " " + resultsSearch.number;
      this.newMembership.zipcode = resultsSearch.postalcode;
      this.newMembership.birthday = resultsSearch.birthday;
      this.newMembership.city = resultsSearch.city;
      this.newMembership.salonhubId = resultsSearch.id;
    },

    clearSignature(){
      this.$refs.signature.clear();
    },

    goToPreview(){
      this.step--;
    },

    goToNext(){
      this.feedback = null;
      let amount = this.newMembership.amount ? true : false; 
  
      if(this.step == 1){
        if(amount){
          this.step = 2;
        }
        else{
          this.feedback = "Vul het bedrag in om door te gaan.";
        }
      }
      else if(this.step == 2){
        let firstName = this.newMembership.firstName ? true : false;
        let lastName = this.newMembership.lastName ? true : false;
        let street = this.newMembership.street ? true : false;
        let zipcode = this.newMembership.zipcode ? true : false;
        let birthday = this.newMembership.birthday && this.newMembership.birthday.length > 0 ? true : false;
        let city = this.newMembership.city ? true : false;
        let signDate = this.newMembership.signDate ? true : false;
        let agreeTermsAndConditions = this.newMembership.agreeTermsAndConditions ? true : false;
        let signature = !this.$refs.signature.isEmpty() ? true : false;

        if(firstName && lastName && birthday && street && zipcode && city && signDate && agreeTermsAndConditions && signature){
          this.newMembership.clientSignature = this.$refs.signature.save();
          this.step = 3;
        }
        else{
          this.feedback = "Vul alle gegevens in om door te gaan.";
        }
      }
    },

    onCardFileSelect() {
      this.$refs.cardFileInput.click();
    },

    onIdFileSelect() {
      this.$refs.idFileInput.click();
    },

    onIdFilePicked(event) {
      this.feedback = null;
      const files = event.target.files;
      this.idFile = files[0];
      let filename = files[0].name;
      this.idFilename = filename;
      console.log("files: " + filename);
      if (filename.lastIndexOf(".") <= 0) {
        this.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.newMembership.clientIdFile = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.idImage = files[0];
      this.feedback = null;
    },

     onCardFilePicked(event) {
      this.feedback = null;
      const files = event.target.files;
      this.cardFile = files[0];
      let filename = files[0].name;
      this.cardFilename = filename;
      console.log("files: " + filename);
      if (filename.lastIndexOf(".") <= 0) {
        this.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.newMembership.clientCardFile = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.cardImage = files[0];
      this.feedback = null;
    },

    getClientDataById(id){
      const urlCustomerId = `https://engine.salonhub.nl/001/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/getCustomer?id=${encodeURI(id)}`
      fetch(urlCustomerId)
      .then(response => response.json())
      .then(data => {
        if(data){
          this.newMembership.firstName = data.firstname;
          this.newMembership.lastName = data.middlename + " " + data.lastname;
          this.newMembership.street = data.address + " " + data.number;
          this.newMembership.zipcode = data.postalcode;
          this.newMembership.city = data.city;
          this.newMembership.salonhubId = +data.id;
        }
      })
    },

    addMembership() {
      this.feedback = null;
      let amount = this.newMembership.amount ? true : false; 
      let firstName = this.newMembership.firstName ? true : false;
      let lastName = this.newMembership.lastName ? true : false;
      let birthday = this.newMembership.birthday && this.newMembership.birthday.length > 0 ? true : false;
      let street = this.newMembership.street ? true : false;
      let zipcode = this.newMembership.zipcode ? true : false;
     
      let city = this.newMembership.city ? true : false;
      let signDate = this.newMembership.signDate ? true : false;
      let agreeTermsAndConditions = this.newMembership.agreeTermsAndConditions ? true : false;

      let idImage = this.newMembership.clientIdFile || this.extendAgreement ? true : false;
      let cardImage = this.newMembership.clientCardFile || this.extendAgreement ? true : false;
      let iban = this.newMembership.iban || this.extendAgreement ? true : false;

      if(amount && firstName && birthday && lastName && street && zipcode && city && signDate && agreeTermsAndConditions && cardImage && idImage && iban){
        this.uploading = true;

        let fileUrls = {
          signatureUrl: null,
          idUrl: null,
          cardUrl: null
        };

        new Promise((resolve, reject)=>{
          let counter = 0;
          let files = new Array();

          if(!this.extendAgreement){   
            files = [
              {
                id: 'signature', 
                fileVar: 'signatureUrl', 
                field: 'clientSignature',
                url: this.activeCompData.id + "/" + "sign/" + this.activeCompData.id + "-" + moment().format("X")+ "membership-sign.png"
              },
              {
                id: 'id', 
                fileVar: 'idUrl', 
                field: 'clientIdFile',
                url: this.activeCompData.id + "/" + "membership/id/" + this.activeCompData.id + "-" + moment().format("X")+  this.idFilename.slice(this.idFilename.lastIndexOf("."))
              },
              {
                id: 'card', 
                fileVar: 'cardUrl', 
                field: 'clientCardFile',
                url: this.activeCompData.id + "/" + "membership/card/" + this.activeCompData.id + "-" + moment().format("X")+  this.idFilename.slice(this.cardFilename.lastIndexOf("."))
              }
            ];
          }
          else{
            this.newMembership.clientSignature = this.$refs.signature.save();
            files = [
              {
                id: 'signature', 
                fileVar: 'signatureUrl', 
                field: 'clientSignature',
                url: this.activeCompData.id + "/" + "sign/" + this.activeCompData.id + "-" + moment().format("X")+ "membership-sign.png"
              },
             ]
          }

          console.log("files: ", files)

          files.forEach(file => {
            let uploadTask = firebase.storage().ref(file.url).putString(this.newMembership[file.field].split(",")[1], "base64" );

            uploadTask.on(
              "state_changed",
              taskSnapshot => {},
              error => {
                console.log(error);
              }, () => {
                console.log("The upload is compleet:", file.id);
                uploadTask.snapshot.ref
                .getDownloadURL()
                .then(url => {
                  fileUrls[file.fileVar] = url;
                  counter++
                  if(counter == files.length){
                    resolve()
                  }
                })
                .catch(error => {
                  reject(error)
                });
              }
            );
          });
        })
        .then(()=>{
          db.collection("memberships").add({
            companyId: this.activeCompData.id,
            agreeTermsAndConditions: this.newMembership.agreeTermsAndConditions,
            firstName: this.newMembership.firstName,
            lastName: this.newMembership.lastName,
            street: this.newMembership.street,
            zipcode: this.newMembership.zipcode,
            birthday: this.newMembership.birthday,
            city: this.newMembership.city,
            country: this.newMembership.country,
            branch: this.newMembership.branch,
            type: this.newMembership.type,
            amount: this.newMembership.amount,
            salonhubId: this.newMembership.salonhubId ? +this.newMembership.salonhubId : null,
            dateAdded: new Date(),
            signDate: this.newMembership.signDate,
            clientSignature: fileUrls.signatureUrl,
            clientIdUrl: this.extendAgreement ? null : fileUrls.idUrl,
            clientCardUrl: this.extendAgreement ? null : fileUrls.cardUrl,
            iban: this.newMembership.iban ? this.newMembership.iban : null,
          })
          .then(()=>{
            this.uploading = false;
            this.closeAddMembershipDialog();
            this.$emit("updateData");
          })
          .catch(err => {
            this.feedback = "Fout bij opslaan. Probeer het opnieuw."
            console.error("Error adding document to membership", err);
          });
        })
        .catch((error)=>{
          this.uploading = false;
          this.uploadProgress = null;
          this.feedback = "Fout bij opslaan. Probeer het opnieuw."
          console.error("File upload promise rejected: ", error)
        })
      }
      else{
        if(!firstName || !lastName || !street || !zipcode || !city ){
          this.feedback = "Vul naam en adresgegevens in."
        }
        else if(!signDate){
          this.feedback = "Vul datum van ondertekening in."
        }
        else if(!agreeTermsAndConditions){
          this.feedback = "Accepteer de algemene voorwaarden"
        }
        else if(!cardImage){
          this.feedback = "Upload Paspoort/Id-kaart"
        }
        else if(!idImage){
          this.feedback = "Upload Bankpas"
        }
        else if(!iban){
          this.feedback = "Vul IBAN (rekeningnummer) in"
        }
      }
    },

    formatDate(date) {
      // Datum omvormen naar Europese leesbare datum
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    }
  },

   watch: {
    zoekSalonhubClient() {
      const url = `https://engine.salonhub.nl/001/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/searchCustomer?salon=*&query=${encodeURI(this.zoekSalonhubClient)}`
      const urlCustomerId = `https://engine.salonhub.nl/001/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/getCustomer?id=${encodeURI(this.zoekSalonhubClient)}`
    
      return new Promise(resolve => {
        let counter = 0;
        if (!this.zoekSalonhubClient || (this.zoekSalonhubClient && this.zoekSalonhubClient.length < 3)) {
          this.searchResultsSalonhub = [];
          return resolve([])
        } 
        else {
          this.searchResultsSalonhub = [];
          this.loaderSearch = true;
          fetch(url)
          .then(response => response.json())
          .then(data => {
            counter++
            if(counter == 2){
              resolve()
            }
            this.searchResultsSalonhub = data.slice(0,15)
          })
          fetch(urlCustomerId)
          .then(response => response.json())
          .then(data => {
            if(data){
              this.searchResultsSalonhub.unshift(data);
            }
            counter++
            if(counter == 2){
              resolve()
            }
          })
        } 
      })
      .then(()=>{
        this.loaderSearch = false
      })
    },
  },

  computed: {
    countryTerms(){
      if(this.newMembership.country == 'be'){
        return "https://beautybyroos.be/algemene-voorwaarden/"
      }else{
        return "https://beautybyroos.nl/algemene-voorwaarden/"
      }
    },
    extendAgreement(){
      if(this.newMembership.type == 'extension' || this.newMembership.type == 'extensionFour' || this.newMembership.type == 'extensionSeiseta' || this.newMembership.type == 'extensionFourSeiseta' ){
        return true
      }
      else{
        return false
      }
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
     theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    signDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.formatDate(this.newMembership.signDate);
    },
  }
};
</script>
